(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetaDeleteController',ZetaDeleteController);

    ZetaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Zeta'];

    function ZetaDeleteController($uibModalInstance, entity, Zeta) {
        var vm = this;

        vm.zeta = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Zeta.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
